








import Vue from 'vue'
import style from './style.module.scss'

// turquoise

export default Vue.extend({
    name: 'notice',
    components: {

    },
    props: {
        color: String
    },
    data() {
        return {
            style: style
        }
    },
    computed: {
        rootClassList(): string[] {

            const classList: string[] = [this.style.notice];

            switch (this.color) {
                // case 'turquoise':
                //     classList.push(this.style.noticeTurquoise);
                //     break;
            
                default:
                    classList.push(this.style.noticeTurquoise);
                    break;
            }

            return classList;
        }
    }
})
